import { QueryClient } from '@tanstack/react-query';
import { LoaderFunctionArgs } from 'react-router';
import { Role } from '@wavingroup/iot-core/gen/ts/wavin/ignite/v1/user_pb';
import { listDeviceStatesQuery } from '~/shared/api/listDeviceStates.queries';
import { checkAuthAndRole } from '~/shared/auth/auth-utils';
import { RoleModel } from '~/shared/models/role/RoleModel';
import { DeviceStatesListModel } from '~/shared/models/deviceStatesList/DeviceStatesListModel';

export type DeviceStatesListPageLoaderData = DeviceStatesListModel;

export const deviceStatesListPageLoader =
  (queryClient: QueryClient) =>
  async ({ request }: LoaderFunctionArgs) => {
    await checkAuthAndRole(
      queryClient,
      request,
      new RoleModel(Role.DEVICE_ADMIN),
    );

    return await queryClient.ensureQueryData(listDeviceStatesQuery);
  };
